import * as yup from "yup";

export const StateSetupValidationSchema = yup.object({
  name: yup
    .string()
    .required("State Name is required")
    .min(1, "Minimum length 1 characters")
    .max(60, "Maximum length 60 characters"),
  shortCode: yup
    .string()
    .required("State Short Code is required")
    .min(1, "Minimum length 1 characters")
    .max(3, "Maximum length 3 characters"),
  country: yup
    .string()
    .required("Country is required"),
})